import React from 'react'
import {
  Book,
  Folder
} from 'react-feather'
import { TabItem } from '../../../components'

const ListNav = ({embed}) => {
  const [selected, setSelected] = React.useState('Upcoming Events')
  const mobilePadding = embed ? 'pt-2 px-3 pb-2' : 'pt-5 px-5 pb-3'

  return (
    <div className="flex border-b mb-5 lg:mb-8">
      <TabItem
        selected={selected}
        onClick={setSelected}
        text="Upcoming Events"
        icon={<Book style={{width: '20px'}}/>}
        className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1`}
        accent={embed ? false : true}
        uppercase={embed ? false : true}
        embed
      />
      <TabItem
        selected={selected}
        onClick={setSelected}
        text="Past Event"
        icon={<Folder style={{width: '20px'}}/>}
        className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1 lg:ml-12`}
        accent={embed ? false : true}
        uppercase={embed ? false : true}
        embed
      />
    </div>
  )
}

export { ListNav }